function t(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 275;
  var _ref = function (t) {
      var e = new RegExp("[぀-ヿ㐀-䶿一-鿿豈-﫿ｦ-ﾟ]", "g"),
        n = (t.match(e) || []).length;
      return {
        count: n,
        time: n / 500,
        formattedText: t.replace(e, "")
      };
    }(t),
    n = _ref.count,
    r = _ref.time,
    c = _ref.formattedText,
    o = function (t) {
      var e = new RegExp("\\w+", "g");
      return (t.match(e) || []).length;
    }(c);
  return {
    characters: n,
    otherLanguageTime: r,
    words: o,
    time: o / e
  };
}
function e(t) {
  return t < .5 ? "less than a min" : t >= .5 && t < 1.5 ? "1 min read" : Math.ceil(t) + " min read";
}
function n(t) {
  return t < .5 ? .5 : t >= .5 && t < 1.5 ? 1 : Math.ceil(t);
}
function r(r) {
  var c = function (t) {
      var e = new RegExp("<\\w+(\\s+(\"[^\"]*\"|\\'[^\\']*'|[^>])+)?>|<\\/\\w+>", "gi");
      return t.replace(e, "");
    }(function (t) {
      return t.replace(/^\s+/, "").replace(/\s+$/, "");
    }(r)),
    _t = t(c),
    o = _t.time,
    i = _t.words;
  return {
    text: e(o),
    minutes: n(o),
    words: i,
    time: o
  };
}
export { r as useReadingTime };